(function() {
	'use strict';
	angular.module('app.leanProjects')
		.service('issueFormService', issueFormService);

	issueFormService.$inject = ['$http', 'hostUrl', 'leanFilterService'];
	function issueFormService($http, hostUrl, leanFilterService) {
		return {
			getIssue: getIssue,
			createIssue: createIssue,
			updateIssue: updateIssue,
			deleteIssue: deleteIssue
		};
	
		function getIssue(issueNdx, projectNdx, leanDirFactoryNdx) {
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projectNdx + '/Issue/' + issueNdx;
			return $http.get(url)
				.then(getIssueSuccess)
				.catch(getIssueFailed);

			function getIssueSuccess(response) {
				return response;
			}

			function getIssueFailed(error) {
				return error;
			}
		}

		function createIssue(issue, projectNdx, leanDirFactoryNdx) {
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projectNdx + '/Issue';
			return $http.post(url, issue)
				.then(createIssueSuccess)
				.catch(createIssueFailed);

			function createIssueSuccess(response) {
				return 'leanProject.toast.createIssueSuccess';
			}

			function createIssueFailed(error) {
				if (error.status === 403) {
					return '';
				}
				return 'Unknown server error';
			}
		}

		function updateIssue(issue, projectNdx, leanDirFactoryNdx, lastModified) {
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projectNdx + '/Issue/' + issue.ndx;
			return $http.put(url, issue, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updateIssueSuccess)
				.catch(updateIssueFailed);
			
			function updateIssueSuccess(response) {
				return 'leanProject.toast.updateIssueSuccess';
			}

			function updateIssueFailed(error) {
				if (error.status === 403) {
					return '';
				} else if (error.status === 412) {
					return 'leanProject.toast.updateIssueConflict';
				}
				return 'Unknown server error';
			}
		}

		function deleteIssue(issueNdx, projectNdx, leanDirFactoryNdx) {
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projectNdx + '/Issue/' + issueNdx;
			return $http.delete(url)
				.then(deleteIssueSuccess)
				.catch(deleteIssueFailed);

			function deleteIssueSuccess(response) {
				return 'leanProject.toast.deleteIssueSuccess';
			}

			function deleteIssueFailed(error) {
				return 'Unknown server error';
			}
		}
	}
})();
